import script from "./recommendConfig.vue?vue&type=script&lang=ts&setup=true"
export * from "./recommendConfig.vue?vue&type=script&lang=ts&setup=true"

import "./recommendConfig.vue?vue&type=style&index=0&id=134bb6cc&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-134bb6cc"]])

export default __exports__